import { render, staticRenderFns } from "./SettingsAdvanced.vue?vue&type=template&id=4485619c&"
import script from "./SettingsAdvanced.vue?vue&type=script&lang=js&"
export * from "./SettingsAdvanced.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAdvanced.vue?vue&type=style&index=0&id=4485619c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports